module.exports = __webpack_public_path__ + "img/34.b41a0413.png";